import { render, staticRenderFns } from "./itemsCard2.vue?vue&type=template&id=f61a5628&"
import script from "./itemsCard2.vue?vue&type=script&lang=js&"
export * from "./itemsCard2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports